import React from "react";
import { CTAButton } from "./CTAButton";
import { LeadResponsePanel } from "./LeadResponsePanel";
import { VideoPlayer } from "./VideoPlayer";
import { scrollToHow } from "../utils/scroll";
import { secondaryButtonClass } from "../utils/buttonStyles";

/** Rendered without entrance animations so it is visible on first paint. */
export function Hero() {
  return <section id="top" aria-labelledby="hero-title" className="border-b border-line" data-id="element-221" data-mp="4jvw9cbadaws">
      <div className="page-container grid grid-cols-1 gap-16 pb-14 pt-6 md:pb-[72px] md:pt-12 lg:grid-cols-12 lg:gap-8 lg:pb-[120px] lg:pt-24" data-id="element-222" data-mp="127edzcmxdncx">
        <div className="lg:col-span-7 lg:pr-6" data-id="element-223" data-mp="sai4b3laiv6s">
          <p className="eyebrow" data-id="element-224" data-mp="sde2mt11vlvr">Sistema de respuesta y seguimiento de leads · Miami</p>
          <h1 id="hero-title" className="h1-hero mt-3 md:mt-4" data-id="element-225" data-mp="nbosrgpkde99">
            Estás pagando por leads. Si nadie responde rápido,{" "}
            <span className="text-gold" data-id="element-226" data-mp="382fedm0930dv">la competencia se queda con la venta.</span>
          </h1>

          {/* Mobile: video right under the headline */}
          <div className="-mx-3 mt-5 md:hidden" data-id="element-227" data-mp="3j924znc7pov0">
            <VideoPlayer mode="poster" data-id="element-228" data-mp="3o7c1c19oavi7" />
          </div>

          <p className="body-copy mt-6 hidden md:block" data-id="element-229" data-mp="3o73q0dt77y94">
            No venimos a venderte más anuncios. Instalamos el sistema para que los leads
            que ya estás pagando reciban respuesta inmediata, seguimiento automático y
            queden registrados en un pipeline claro.
          </p>

          <div className="mt-5 flex flex-col gap-4 sm:flex-row sm:items-start md:mt-10" data-id="element-230" data-mp="30gq4l654cxni">
            <CTAButton source="hero" data-id="element-231" data-mp="35aausc0h0nc5" />
            <button type="button" onClick={scrollToHow} className={`${secondaryButtonClass} hidden min-h-[56px] w-full px-8 text-[15px] sm:w-auto md:inline-flex`} data-id="element-232" data-mp="2qjv8etwbj9ce">
              Ver cómo funciona →
            </button>
          </div>

          <p className="body-copy mt-4 md:hidden" data-id="element-233" data-mp="2hlj8g19kaz7a">
            Instalamos el sistema para que los leads que ya pagas reciban respuesta,
            seguimiento y control.
          </p>

          <p className="mt-10 hidden max-w-[62ch] border-t border-line pt-5 text-[14px] leading-snug text-muted md:block" data-id="element-234" data-mp="s44hnmgsjjhd">
            <span className="font-ui font-bold text-gold" data-id="element-235" data-mp="ic87hd1fk2ws">
              Programa Cliente Fundador — solo 3 cupos
            </span>{" "}
            · Aventura, North Miami, Sunny Isles, Hallandale, Hollywood
          </p>
        </div>

        <div className="hidden md:block lg:col-span-5 lg:pt-2" data-id="element-236" data-mp="1azuk1asmyhvs">
          <LeadResponsePanel data-id="element-237" data-mp="161t06nndyej9" />
        </div>
      </div>
    </section>;
}